import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { ContactsPageMobile } from "@/pages/ContactsPage/mobile";
import { ContactsDesktop } from "./components";

export const ContactsPageContent = () => {
  // TODO: Change mobile to ContactsMobile after refactor
  return <ResponsiveBlockSwitcher desktop={<ContactsDesktop />} mobile={<ContactsPageMobile />} />;
};
